var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11111 7.43748C0.497468 7.43748 0 7.91317 0 8.49999C0 9.08681 0.497468 9.56249 1.11111 9.56249L16.2064 9.56249L10.3255 15.1862C9.89158 15.6011 9.89158 16.2739 10.3255 16.6888C10.7594 17.1037 11.4629 17.1037 11.8968 16.6888L19.6745 9.25128C20.1085 8.83637 20.1085 8.1636 19.6745 7.74869L11.8968 0.31118C11.4629 -0.103728 10.7594 -0.103728 10.3255 0.31118C9.89158 0.726085 9.89158 1.39886 10.3255 1.81377L16.2064 7.43748L1.11111 7.43748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.f600dde804d12c8e48c3aa019f5dd979.svg";
export { ForwardRef as ReactComponent };